const cn={
    // {{ $t("button.Search") }}
    "button":{
        "Back":"返回",
        "Add":"添加",
        "Search":"查询",
        "Find":"搜索",
        "Delete":"删除",
        "Reset":"重置",
        "Edit":"编辑",
        "Save":"保存",
        "Pass":"通过",
        "Return":"打回",
        "ReturnPage":"返回",
        "Upload and Check":"上传并查看",
        "Upload to the database":"上传至数据库",
        "Modify the information":"修改信息",
        "Modify the password":"修改密码",
        "Log in":"登录",
        "Log out":"退出登录",
        "Go back and Log in":"返回登录",
        "Register":"注册",
        "Add the information of Country":"添加国家信息",
        "Add the information of City":"添加城市信息",
        "Add the information of Index":"添加指标信息",
        "Add the information of Data":"添加数据",
        "Compute":"计算",
        "NotVerify":"未审核",
        "AlreadyVerify":"已审核",
        "ReturnVerify":"已打回"
    },
    "title":{
        "Login Title":"登录您的账号",
        "Register Title":"注册您的账号",
        "Modify Title":"修改账户信息",
        "Change Title":"修改密码",
        "Main Title":"世界旅游城市报告数据库",
        "Compute":"指标分数计算",
        "Introduction":"关于世界旅游城市报告数据库系统",
        "Introduction1":"世界旅游城市报告数据库系统用于实现世界旅游城市报告数据在旅游城市、专业旅游机构间的交流共享",
        "Introduction2":"促进世界旅游城市报告数据内在价值的多维度、深入挖掘，促进世界旅游城市联合会业务流程一体化、自动化",
        "Introduction of Video Train":"视频培训课程简介",
    },
    "tips":{
        "Login tips1":"如您是第一次使用该系统，请先注册",
        "Login tips2":"注册成功之后， 需要管理员对账户进行权限授予",
        "Login tips3":"再使用用户名和密码登录本系统",
        "Compute":"提示：",
        "Compute1":"该功能用于计算一整年所有城市所有级指标的得分",
        "Compute2":"选择需要计算的年份",
        "Compute3":"则可以计算该年所有指标的得分",
        "Modify tips1":"旧密码不能为空",
        "Modify tips2":"旧密码错误",
        "Modify tips3":"新密码不能为空",
        "Modify tips4":"请输入确认密码",
        "Modify tips5":"密码长度在3至20个字符之间",
        "Modify tips6":"新密码和确认密码不一致",
        "Modify tips7":"新密码和旧密码一致"
    },
    "Login and Register":{
        "Username":"用户名",
        "Password":"密码",
        "Confirm Password":"确认密码",
        "New Password":"新密码",
        "Old Password":"旧密码",
        "Organization":"所属机构",
        "City":"所属城市",
        "Phone number":"电话号码",
        "Email":"邮箱地址",

        "UsernameTip":"用户名不能为空",
        "PasswordTip1":"密码不能为空",
        "PasswordTip2":"密码长度在3至20个字符之间",
        "ConfirmPasswordTip1":"请再次输入密码",
        "ConfirmPasswordTip2":"两次输入密码不一致!",
        "PhoneNumberTip1":"请输入有效电话号码",
        "PhoneNumberTip2":"电话号码不能为空",
        "CityNameTip1":"所属城市不能为空",
        "EmailTip1":"请输入邮箱地址",
        "EmailTip2":"请输入正确的邮箱地址",
    },
    "Navigation":{
        "Data Search Module":"数据查询模块",
        "City Evaluation System":"城市评价体系查询",
        "City Detail Data":"城市详细数据查询",
        "City Index Rank":"城市指标排名查询",

        "Data Analysis Module": "数据分析模块",
        "Comparative Analysis of City Data":"城市数据对比分析",
        "Trend Analysis of City Data":"城市数据变化趋势分析",

        "Account Management Module":"账户管理模块",
        "Account Permission Modification":"账户权限修改",

        "Data Maintenance Module": "数据维护模块",
        "City Management": "城市管理",
        "Index Management": "指标管理",
        "Data Management": "数据管理",
        "Index calculation": "指标计算",

        "Data Upload Module": "数据上传模块",
        "Batch Data Upload": "数据批量上传",

        "Data Audit Module":"数据审核模块",
        "Batch Data Audit": "数据批量审核",

        "Video Train Module":"培训视频模块",
        "Video Train": "培训视频介绍",

        "City Evaluation System1":"查询不同年份的评价体系",
        "City Detail Data1":"查询不同城市在不同年份的指标值和指标分数",
        "City Index Rank1":"查询所有城市根据不同指标值的排名",

        "Comparative Analysis of City Data1":"查询某年份两个城市的指标值对比图",
        "Trend Analysis of City Data1":"查询某城市的指标发展趋势图",

        "City Management1": "添加国家和城市信息；修改城市信息",
        "Index Management1": "添加和修改指标信息",
        "Data Management1": "添加和修改数据信息",
        "Index calculation1": "计算所有城市指标的得分",
    },
    // :placeholder="$t('placeholder.Search')"
    "placeholder":{
        "Year":"年份",
        "Year1":"年份（可多选）",
        "Year2":"年份*",
        "Year3":"选择要查询的年份*",

        "Index":"指标",
        "Index1":"指标（可多选）",
        "Index2":"指标*",
        "Index3":"指标值",
        "Index4":"指标分数",
        "Index5":"(中)指标名称*",
        "Index5-e":"(英)指标名称*",
        "Index6":"父指标名称（选填）",
        "Index6-e":"(英)父指标名称（选填）",
        "Index7":"(中)指标的单位（选填）",
        "Index7-e":"(英)指标的单位（选填",
        "Index8":"指标的权重（选填）",

        "City0":"城市",
        "City":"城市*",
        "City1":"城市1*",
        "City2":"城市2*",
        "City3":"城市（可选）",
        "City4":"城市（可多选）",
        "City5":"城市",
        "City5CN":"(中)城市*",
        "City5EN":"(英)城市*",

        "Search":"根据用户名进行搜索",
        "Continent":"洲",
        "Country":"国家",
        "Country1CN":"(中)国家*",
        "Country1EN":"(英)国家*",
        "Country1":"国家"
    },
    // :label="$t('label.Search')"
    "label": {
        "item_name":"item.name_cn",
        "oneIndex": "一级指标",
        "oneIndexValue": "一级指标权重（%）",
        "twoIndex": "二级指标",
        "twoIndexValue": "二级指标权重（%）",

        "Rank":"排名",
        "CityName":"城市",
        "CityNameCN":"城市(中)",
        "CityNameEN":"城市(英)",
        "IndexName":"指标",
        "IndexNameCN":"指标(中)",
        "IndexNameEN":"指标(英)",
        "Score":"指标分数",
        "IndexYear":"年份",
        "Value":"指标值",
        "Continent":"洲" ,
        "Continent-1":"城市所属洲" ,
        "Country":"国家" ,
        "Country-1":"城市所属国家" ,
        "Operation":"操作" ,
        "Unit":"单位",
        "UnitCN":"单位(中)",
        "UnitEN":"单位(英)",
        "Weight":"权重" ,
        "Parent":"父级指标" ,

        "ReturnTime":"打回时间",
        "ConfirmTime":"审核时间",
        "UploadTime": "上传时间",
        "UploaderUsername": "上传者",
        "ConfirmerUsername": "审核者",
        "Source": "数据源",
        "Approved": "审核通过",
        "Username": "用户名",
        "Organization": "所属机构",
        "City": "所属城市",
        "PhoneNumber": "手机号码",
        "Email": "邮箱",
        "Opening Account": "开通账户",
        "Roles":"角色",
        "Open":"开通",
        "Close":"关闭",
        "empty":"暂无数据"
    },
    "video": {
        "Cultural and Tourism Product Investment":"文旅产品投资与中国游客消费需求——王笑宇老师",
        "Sustainable Travel and Tourism":"可持续旅游：旅游目的地的最佳实践——陈怡宁老师",
        "Innovative Technology":"科技创新促进中国城市旅游复苏——张慧英老师",
        "Market Logic and Evolution of Sports Tourism":"中国体育旅游的市场逻辑与业态演化——蒋依依老师",
        "Introduction of Cultural and Tourism Product Investment":"课程从“一带一路”资源与市场现状、中国文旅消费需求变化趋势、“一带一路”文旅投资与趋势、“一带一路”的投资风险控制四个方面对文旅产品投资与中国游客消费需求进行分析。提出中国的休闲度假消费都幅度增长，更加注重品质和体验。当前“一带一路”文旅投资从重资产的酒旅投资向轻资产的线上、娱乐、商业等领域转型。",
        "Introduction of Sustainable Travel and Tourism":"课程从旅游可持续发展的必要性、游客的言行差距、旅游可持续发展的产品方案和最佳实践四个方面对旅游目的地可持续发展进行阐述。旅游是实现联合国可持续发展目标的重要手段，许多游客都认识到了这一点，但是他们在旅游的实际过程中会因为种种原因选择更不可持续的方式。因此，想要打造可持续发展的旅游目的地，需要对产业进行补贴，减少二氧化碳排放，还可以通过提供可持续旅游产品、改变游客思维等方式达成可持续的目标。",
        "Introduction of Innovative Technology":"课程主要分为中国旅游市场概述和中国旅游创新案例两个部分。课程指出，中国旅游市场在疫情后快速复苏，游客偏好中对文化和历史的偏好增加。直播、OTA、酒店、航空等多个领域都针对剧增的旅游需求和全新的游客偏好做出调整。故宫和798艺术园区作为北京的两个重要的文化场所，将科技与旅游相融合，给游客带来全新的旅游体验。",
        "Introduction of Market Logic and Evolution of Sports Tourism":"课程从政策支持、市场趋势、产业发展和业态变化这四个方面进行讲解。中国的国家政策大力支持体育运动的发展，推动体育与旅游跨产业融合。市场表现出体育旅游爱好者根据体育运动选择旅游目的地、客群年轻化和旅游体育体验多样化、个性化这三大特点。在此基础上，体育旅游产业扩大，形成以赛事为核心的旅游产业链，并进一步推动相关产业发展。整个体育旅游业态向着品质化、精品化、多元化的方向迈进。"
    }
}
export default cn